import React from 'react';
import './HisStory.css';
import PuzzleFact from '../PuzzleFact/PuzzleFact';

const HisStory = () => {
  return (
    <section id="his-story" className="his-story-section">
      <div className="his-story-container">
        <div className="his-story-left-half">
          <div className="his-story-image">
            <img src="/his_story.jpg" alt="Flower" />
          </div>
        </div>
        <div className="his-story-content">
          <h2 className="his-story-title">His<br/>Story</h2>
          <div className="his-story-divider"></div>
          
          <div className="his-story-text">
            <p>
              <PuzzleFact factId="decoy-dating-app" />, with the most casual thoughts to just meet someone for dates, yet I didn't know I met the love of my life.
            </p>
            <p>
              It was during Covid quarantine. we were keeping it casual, a chat in the morning and one at night. Soon this became a habit, an intoxicating habit that I was just looking at my phone the whole day waiting to receive a message from her.
            </p>
            <p>
              We soon moved in together, sharing the same roof, same bed. We have grown to know each other better, love each other even more. Our differences in lifestyle didn't start quarrels, they became endless discussions from which we learnt to know each other even better.
            </p>
            <p>
              I proposed two days before <PuzzleFact factId="proposal-holiday" />, it was the exact two years that we've started chatting. It's only been two years, but it's already two years too late to propose, and decades too late to know and meet her.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HisStory;
